<ng-container *transloco="let t; read: 'formFieldAutocomplete'">
  <ng-container [formGroup]="autocompleteGroup">
    <mat-form-field *ngIf="!field.multiple" class="form-field">
      <mat-label>{{ field.name }}</mat-label>
      <input
        type="text"
        matInput
        #autocompleteInput
        formControlName="autocomplete"
        [matAutocomplete]="auto"
        [required]="parentFormGroup.get(field.key).errors?.required"
        (focus)="onFocus()"
        (blur)="onBlur($event)"
        [readonly]="field.readonly === true"
      />
      <button
        *ngIf="showClearButton && !field.readonly"
        (click)="clearField($event)"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="selectedSingle($event)"
        [displayWith]="displayAutocomplete"
      >
        <mat-option
          *ngFor="let option of options$ | async"
          [value]="option"
          [matTooltip]="
            field?.autocompleteTooltipConfig?.isVisible
              ? option.title || option.label || option
              : ''
          "
          [matTooltipPosition]="field?.autocompleteTooltipConfig?.position"
        >
          {{ option.label ? option.label : option }}
        </mat-option>
      </mat-autocomplete>

      <mat-error ngxErrors="autocomplete" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="field.multiple" class="form-field">
      <mat-chip-grid #chipList>
        <mat-chip-row
          *ngFor="let choice of multipleChoices | keyvalue: fakeSort"
          removable
          (removed)="removeMultiple(choice.key)"
        >
          {{ choice.value.label ? choice.value.label : choice.value }}
          <mat-icon matChipRemove>clear</mat-icon>
        </mat-chip-row>
        <input
          type="text"
          matInput
          #autocompleteInput
          placeholder="{{ field.name }}{{
            parentFormGroup.get(field.key).errors?.required ? '*' : ''
          }}"
          formControlName="autocomplete"
          [matAutocomplete]="auto"
          [required]="parentFormGroup.get(field.key).errors?.required"
          (focus)="onFocus()"
          (paste)="onPaste($event)"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="false"
          [readonly]="field.readonly === true"
        />
        <button
          *ngIf="showClearButton && parentFormGroup.get(field.key).enabled && !field.readonly"
          (click)="clearField($event)"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-chip-grid>
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="selectedMultiple($event)"
        [displayWith]="displayAutocomplete"
      >
        <mat-option
          *ngFor="let option of options$ | async"
          [value]="option"
          [matTooltip]="
            field?.autocompleteTooltipConfig?.isVisible
              ? option.label
                ? option.label
                : option
              : ''
          "
          [matTooltipPosition]="field?.autocompleteTooltipConfig?.position"
        >
          {{ option.label ? option.label : option }}
        </mat-option>
      </mat-autocomplete>

      <mat-error ngxErrors="autocomplete" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
